<script setup lang="ts">
const wrapper = ref<Element | null>(null);
const fs = useFullScreenStore();
const store = useSongStore();

const beta = useBetaStore();
const newMidiControls = computed(() => beta.features.midiScrollImprovements);

onMounted(() => {
  if (wrapper.value) {
    fs.setElement(wrapper.value);
  }
});
</script>

<template>
  <div
    ref="wrapper"
    class="full-screen-wrapper"
    :class="{
      'full-screen-mode': fs.fullScreenEnabled,
      'manual-full-screen': fs.manualFullScreenEnabled,
    }"
  >
    <div
      v-if="!store.placeholderNotLoaded"
      class="toolbar controls-center flex items-center justify-between border-b px-2 pb-2 pt-2 sm:pb-3 sm:pt-5 md:px-5"
      :class="{
        'toolbar-sticky-fs': fs.fullScreenEnabled && newMidiControls,
        'toolbar-sticky': newMidiControls,
      }"
    >
      <div class="flex items-center">
        <slot name="toolbar" />
      </div>
      <div>
        <slot name="action-bar-controls" />
      </div>
    </div>

    <div
      v-if="$slots.header"
      class="px-2"
    >
      <slot name="header" />
    </div>

    <div class="main-flex">
      <div class="sheet-container full-width">
        <div
          v-if="store.placeholderNotLoaded"
          class="toolbar border-b"
          style="height: 97px"
        ></div>
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.fullscreen-controls {
  @apply hidden;
}

.full-screen-wrapper.manual-full-screen {
  @apply fixed bottom-0 left-0 right-0 top-0 overflow-y-auto;
  z-index: 10000;
}
.full-screen-wrapper.full-screen-mode {
  @apply overflow-y-auto bg-base-200 p-0;

  .fullscreen-controls {
    @apply flex items-center justify-center;
  }

  .col-controls {
    @apply hidden;

    &.show {
      @apply block;
    }
  }
}

.sheet-container.full-width {
  @apply w-full;
}
.toolbar-sticky {
  @apply sticky z-20 rounded-t-xl bg-light-100;
  top: var(--header-height);
}

.toolbar-sticky-fs {
  @apply sticky top-0 z-20 rounded-t-xl bg-light-100;
}
</style>
